
import { defineComponent } from "vue";
import mixin from "./../../mixin";

export default defineComponent({
    mixins: [
        mixin,
    ],
})
